import { BFLType } from "../../types/DBTables";
import { IGlobalData } from "../../types/globalData";
import { IBIMHandler } from "./bimHandler";
import { IModuleRound, IRoundHandler } from "../roundHandler";
//import { IModuleVattenburetSekundärsystem } from "../../types/ModuleDatas";

import bflHelper from "./bflHelper";
import { IBFModule, IBFResult, IKontrollResultRow, IKontrollResultRowDriftoptimering } from "../../types/BFL/Funktionskontroll";
import { IModuleKylmaskin } from "../../types/ModuleDatas";
import { logAndNotifyError } from "../logger";
import { numFrmtStd } from "../common";

//todo -> make class?!
export const bfk_J1 = (): IBFModule => {
  const bfName = BFLType.BFK_J1;
  const getResult = (module: IModuleRound, bimHandler: IBIMHandler, roundHandler: IRoundHandler, globalData: IGlobalData): IBFResult => {
    //const moduleData: IModuleVattenburetSekundärsystem = module.data;

    let funktionsKontroller: IKontrollResultRow[] = [];
    let driftOptimeringar: IKontrollResultRowDriftoptimering[] = [];
    let data = {} as any;
    let dbg = {} as any;
    let error: any = undefined;

    const bH = bflHelper.bflHelper();

    try {
      //Modules
      const moduleData = module.data as IModuleKylmaskin;

      const j1ÅrligEnergianvändningKyla = moduleData.årligAvgivning;
      const j1ÅrligEnergianvändningEl = moduleData.årligElanvändning;
      const j1UppdateratKylmaskin = moduleData.harUppdateradStatistik;
      const j1NormalVerkningsgrad = globalData.Kyla.Kylform_Faktor.find((k) => k.Kylform === "Kylmaskin")?.Faktor as number;
      const j1GränsvärdeVerkningsgrad = j1NormalVerkningsgrad - 0.75;

      //=j1ÅrligEnergianvändningKyla/j1NormalVerkningsgrad
      const j1NormalAnvändning = j1ÅrligEnergianvändningKyla / j1NormalVerkningsgrad;
      //=j1ÅrligEnergianvändningKyla/j1GränsvärdeVerkningsgrad
      const j1GränsvärdeAnvändning = j1ÅrligEnergianvändningKyla / j1GränsvärdeVerkningsgrad;
      //=IF(j1ÅrligEnergianvändningEl>j1GränsvärdeAnvändning;(j1ÅrligEnergianvändningEl-j1NormalAnvändning);0)
      const j1ÖverkonsumptionLågKylfaktor = j1ÅrligEnergianvändningEl > j1GränsvärdeAnvändning ? j1ÅrligEnergianvändningEl - j1NormalAnvändning : 0;

      //=IF(j1UppdateratKylmaskin="Ja";1;0)
      const j1FunktionakontrollVilkor1 = j1UppdateratKylmaskin === "Ja" ? 1 : 0;
      //=IF(j1UppdateratKylmaskin="Nej";1;0)
      const j1FunktionakontrollVilkor2 = j1UppdateratKylmaskin === "Nej" ? 1 : 0;
      //=IF(AND(j1ÖverkonsumptionLågKylfaktor<1;j1UppdateratKylmaskin="Ja");1;0)
      const j1FunktionakontrollVilkor3 = j1ÖverkonsumptionLågKylfaktor < 1 && j1UppdateratKylmaskin === "Ja" ? 1 : 0;
      //=IF(j1ÖverkonsumptionLågKylfaktor>1;1;0)
      const j1FunktionakontrollVilkor4 = j1ÖverkonsumptionLågKylfaktor > 1 ? 1 : 0;

      const statistikUppdateradText =
        j1UppdateratKylmaskin === "Ja"
          ? globalData.Funktionskontroller.mapFunktionskontroller.BFKJ1_FKText1.Text + " " + new Date().toLocaleDateString("sv-SE")
          : globalData.Funktionskontroller.mapFunktionskontroller.BFKJ1_FKText2.Text;
      //=IF(AND(j1UppdateratKylmaskin="Ja";j1ÅrligEnergianvändningEl>0);j1ÅrligEnergianvändningKyla/j1ÅrligEnergianvändningEl;"")
      const uppmättKylfaktor = j1UppdateratKylmaskin === "Ja" && j1ÅrligEnergianvändningEl > 0 ? j1ÅrligEnergianvändningKyla / j1ÅrligEnergianvändningEl : undefined;

      //=IF(OR(j1UppdateratKylmaskin="Nej";j1FunktionakontrollVilkor3=1);"";j1ÖverkonsumptionLågKylfaktor)
      let kWHperYear = j1UppdateratKylmaskin === "Nej" || j1FunktionakontrollVilkor3 === 1 ? undefined : j1ÖverkonsumptionLågKylfaktor;
      //=IF(OR(j1FunktionakontrollVilkor2=1;j1FunktionakontrollVilkor3=1);"";"EL")
      let energiSlag = j1FunktionakontrollVilkor2 === 1 || j1FunktionakontrollVilkor3 === 1 ? "" : "EL";

      data = {
        export: {
          uppdateratKylmaskin: j1UppdateratKylmaskin,
          statistikUppdateradText,
          uppmättKylfaktor,
        },
      };

      const tabell1 = {
        j1ÅrligEnergianvändningKyla,
        j1ÅrligEnergianvändningEl,
        j1NormalVerkningsgrad,
        j1GränsvärdeVerkningsgrad,
        j1NormalAnvändning,
        j1GränsvärdeAnvändning,
        j1ÖverkonsumptionLågKylfaktor,
        j1FunktionakontrollVilkor1,
        j1FunktionakontrollVilkor2,
        j1FunktionakontrollVilkor3,
        j1FunktionakontrollVilkor4,
        kWHperYear,
        energiSlag,
      };
      dbg = { tabell1 };

      if (j1UppdateratKylmaskin === "Ja") {
        if (j1FunktionakontrollVilkor3 === 1) {
          funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 3, kWHperYear, energiSlag));
          // funktionsKontroller.push({
          //   index: 3,
          //   kWhs: kWHperYear,
          //   energiSlag: energiSlag,
          //   message: globalData.Funktionskontroller.mapFunktionskontroller.BFKJ1_FKText3,
          // });
        } else if (j1FunktionakontrollVilkor4 === 1) {
          funktionsKontroller.push(
            roundHandler.getFunktionsKontroll(bfName, 4, kWHperYear, energiSlag, { formatFn: (n: string) => (uppmättKylfaktor === undefined ? "?" : numFrmtStd.format(uppmättKylfaktor)) })
          );
          // funktionsKontroller.push({
          //   index: 2,
          //   kWhs: kWHperYear,
          //   energiSlag: energiSlag,
          //   message: globalData.Funktionskontroller.mapFunktionskontroller.BFKJ1_FKText4,
          // });
        }
      }
    } catch (ex: any) {
      logAndNotifyError(ex);
      error = ex.toString();
    }

    return {
      bfName: BFLType.BFK_J1,
      funktionsKontroller: bH.cleanFunktionsKontroller(funktionsKontroller),
      driftOptimeringar: bH.cleanDriftoptimeringar(driftOptimeringar),
      note: "",
      data,
      error,
      debug: dbg,
    };
  };

  return { getResult, bfName };
};

const dflt = { bfk_J1 };

export default dflt;
